(() => {
  // YouTube's legacy 4:3 rendition pads a central 16:9 image. Crop the
  // known rendition, including Shopify copies, without inspecting pixels.
  const cropScale = (width, height, boxWidth, boxHeight) => {
    const ratio = width / height;
    if (!boxWidth || !boxHeight || ratio < 1.25 || ratio >= 1.5) return 1;
    const cover = Math.max(boxWidth / width, boxHeight / height);
    return Math.max(1, boxHeight / (height * .75 * cover));
  };
  globalThis.UrbandonedVideoThumbnail = { cropScale };
  if (typeof document === 'undefined') return;

  const selector = 'img[data-video-thumbnail], img[data-youtube-latest-thumbnail], img[data-youtube-video-thumbnail], .uncut-card__image';
  const watched = new WeakSet();
  const update = (image) => {
    if (!image.naturalWidth || !image.naturalHeight) return;
    image.style.setProperty('--video-thumbnail-scale', cropScale(
      image.naturalWidth, image.naturalHeight, image.clientWidth, image.clientHeight,
    ));
  };
  const sizes = new ResizeObserver((entries) => entries.forEach(({ target }) => update(target)));
  const watch = (image) => {
    if (watched.has(image)) return;
    watched.add(image);
    image.setAttribute('data-video-thumbnail', '');
    image.addEventListener('load', () => update(image));
    sizes.observe(image);
    update(image);
  };
  const scan = (node) => {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) watch(node);
    node.querySelectorAll(selector).forEach(watch);
  };
  scan(document.documentElement);
  new MutationObserver((records) => records.forEach((record) => {
    if (record.type === 'attributes') { scan(record.target); update(record.target); }
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-video-thumbnail'] });
})();
